import React from 'react';
import {Loader2} from 'lucide-react';

interface DraftStatusProps {
  isDraftLoading?: boolean;
  isDraftSaving?: boolean;
  className?: string;
}

export const DraftStatus: React.FC<DraftStatusProps> = ({
  isDraftLoading,
  isDraftSaving,
  className = ''
}) => {
  const isVisible = isDraftLoading || isDraftSaving;

  if (!isVisible) return null;

  return (
    <div
      className={`absolute top-0 left-0 right-0 z-10 transition-all duration-300 ${className}`}
      style={{
        transform: isVisible ? 'translateY(0)' : 'translateY(-100%)',
        opacity: isVisible ? 1 : 0,
      }}
    >
      <div
        className="flex items-center justify-center gap-2 text-sm py-3 px-4"
        style={{
          color: 'var(--ef-text-secondary, #6B7280)',
          backgroundColor: 'var(--ef-bg-info, #EFF6FF)',
          borderBottom: '1px solid var(--ef-border-info, #BFDBFE)'
        }}
      >
        <Loader2
          className="animate-spin flex-shrink-0"
          size={16}
          style={{ color: 'var(--ef-primary, #3B82F6)' }}
        />
        <span className="font-medium">
          {isDraftLoading && 'Loading your draft...'}
          {isDraftSaving && 'Saving your progress...'}
        </span>
      </div>
    </div>
  );
};

